module.exports = __webpack_public_path__ + "media/images/buttons/android_download_button-558feee222a94a1008a22f7503b405d4.svg";